import { useEffect, useState, useRef } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2, KeyRound, DollarSign, BadgeCheck } from "lucide-react";
import { StripeConnectButton } from "@/components/StripeConnectButton";

export function MentorAccount() {
  const [me, setMe] = useState(null);
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [savingPw, setSavingPw] = useState(false);
  const [stripeEmail, setStripeEmail] = useState("");
  const [savingEmail, setSavingEmail] = useState(false);
  const didInit = useRef(false);

  const load = async () => {
    try {
      const { data } = await api.get("/referral/me");
      setMe(data);
      // Only prefill the input on the FIRST load so we never overwrite what the user is typing.
      if (!didInit.current) { setStripeEmail(data?.payout_email || ""); didInit.current = true; }
    } catch { /* ignore */ }
  };
  useEffect(() => { load(); }, []);

  const changePassword = async () => {
    if (newPass !== confirmPass) { toast.error("Modpas yo pa menm"); return; }
    setSavingPw(true);
    try {
      await api.post("/referral/change-password", { new_password: newPass });
      toast.success("Modpas chanje!");
      setNewPass(""); setConfirmPass("");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSavingPw(false); }
  };

  const savePayout = async () => {
    setSavingEmail(true);
    try {
      await api.post("/referral/payout-email", { payout_email: stripeEmail });
      toast.success("Imèl Stripe anrejistre!");
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSavingEmail(false); }
  };

  return (
    <div className="max-w-xl space-y-4" data-testid="mentor-account">
      <div className="border border-[#222] bg-[#0c0c0c] rounded-lg p-5">
        <div className="flex items-center gap-2 mb-3">
          <KeyRound className="h-5 w-5 text-[#00F593]" />
          <h3 className="font-heading font-semibold text-white">Chanje Modpas</h3>
        </div>
        <p className="text-xs text-[#888] mb-3">6+ karaktè, gwo lèt, ti lèt, yon senbòl.</p>
        <div className="space-y-2.5">
          <Input data-testid="mentor-new-password" type="password" value={newPass} onChange={(e) => setNewPass(e.target.value)} placeholder="Nouvo modpas" className="bg-black border-[#222] h-11 text-white" />
          <Input data-testid="mentor-confirm-password" type="password" value={confirmPass} onChange={(e) => setConfirmPass(e.target.value)} placeholder="Konfime modpas" className="bg-black border-[#222] h-11 text-white" />
          <Button data-testid="mentor-save-password" onClick={changePassword} disabled={savingPw || !newPass} className="w-full bg-[#00F593] hover:bg-[#00d47f] text-black rounded-lg h-11 font-semibold">
            {savingPw ? <Loader2 className="h-4 w-4 animate-spin" /> : "Anrejistre Modpas"}
          </Button>
        </div>
      </div>

      <div className="border border-[#222] bg-[#0c0c0c] rounded-lg p-5">
        <div className="flex items-center gap-2 mb-1.5">
          <DollarSign className="h-5 w-5 text-[#1C8CFF]" />
          <h3 className="font-heading font-semibold text-white">Konekte Stripe pou Peman</h3>
        </div>
        <p className="text-xs text-[#888] mb-3">Konekte kont Stripe ou pou resevwa komisyon ou yo otomatikman.</p>
        <div className="mb-4">
          <StripeConnectButton variant="mentor" />
        </div>
        <div className="border-t border-[#222] pt-3">
          <p className="text-[11px] text-[#888] mb-2">Oswa bay imèl Stripe ou (backup):</p>
          <div className="flex gap-2">
            <Input data-testid="mentor-stripe-email" type="email" value={stripeEmail} onChange={(e) => setStripeEmail(e.target.value)} placeholder="imel-stripe@egzanp.com" className="bg-black border-[#222] h-11 text-white flex-1" />
            <Button data-testid="mentor-save-stripe" onClick={savePayout} disabled={savingEmail} className="bg-[#161616] hover:bg-[#222] border border-[#222] text-white rounded-lg h-11 px-5">
              {savingEmail ? <Loader2 className="h-4 w-4 animate-spin" /> : "Anrejistre"}
            </Button>
          </div>
          {me?.payout_email && (
            <p className="text-[11px] text-[#00F593] mt-2 flex items-center gap-1.5" data-testid="mentor-payout-saved">
              <BadgeCheck className="h-3.5 w-3.5" /> Imèl Stripe: {me.payout_email}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
